"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Catch = void 0;
var SentryReporter_1 = require("@wix/dealer-common/dist/src/services/SentryReporter/SentryReporter");
var React = require("react");
function Catch(_a) {
    var render = _a.render, _b = _a.onError, onError = _b === void 0 ? function () { return ''; } : _b;
    var comp;
    try {
        comp = render();
    }
    catch (e) {
        SentryReporter_1.reportSentryError(e, { reportingClass: 'Catch' });
        onError(e);
        comp = React.createElement("span", null);
    }
    return comp;
}
exports.Catch = Catch;
//# sourceMappingURL=Catch.js.map